export const camposDirecciones = [
    {
        nombre: 'direccion.numeroPlaca',
        mensaje: 'Número de placa es requerido.',
    },
    {
        nombre: 'direccion.viaGeneradoraNumero',
        mensaje: 'Número de Vía generadora es requerido.',
    },
    {
        nombre: 'direccion.viaPrincipalNumero',
        mensaje: 'Número de Vía Principal es requerido.',
    },
    {
        nombre: 'direccion.viaPrincipalTipo',
        mensaje: 'La via principal es obligatorio.',
    },
];
